module.exports = __webpack_public_path__ + "static/media/ryker.7ea49bb9.png";